<template>
  <div class="orderBox">
    <div class="form-title">保单归属</div>
    <FormItem prop="tenantId" :label="isIFA ? '归属团队' : '归属转介人'" :rules="$units.formRule.required('请选择')">
      <span v-if="disabled">{{ formData.merchantName }}</span>
      <select-tree v-else v-model="formData.tenantId" type="5" url="/buz/merchant/read/tree" :params="{ nodeType: 0 }" :isAll="true" ref="selectTree" :status="1" />
    </FormItem>
    <FormItem
      v-if="!formData.id || (formData.id && formData.tenantId === userInfo.tenantId)"
      prop="agentId"
      label=" 归属业务员"
      :rules="$units.formRule.required('请选择')"
    >
      <span v-if="disabled">{{ formData.agentName }}</span>
      <Select v-else :disabled="!userList.length" v-model="formData.agentId" filterable transfer clearable>
        <Option v-for="item in userList" :value="item.salesmanId" :key="item.salesmanId">{{ item.salesmanName }}</Option>
      </Select>
    </FormItem>
    <FormItem label="预约编号" v-if="formData.reservationNo">
      {{ formData.reservationNo }}
    </FormItem>
    <FormItem label="業務代表" v-if="formData.trInfo">
      {{ formData.trInfo.englishName }}({{ formData.trInfo.userName }})
    </FormItem>
    <FormItem label="客户是否转介" v-if="formData.isReferral">
      {{ formData.isReferral == 1 ? '是' : '否' }}
    </FormItem>
    <FormItem label="客户转介人" v-if="formData.referralName">
      {{ formData.referralName }}
    </FormItem>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};

export default {
  props: ['formData', 'disabled'],
  components: { selectTree },
  data() {
    return {
      userInfo,
      userList: [],
      trList: []
    };
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.selectTree && this.$refs.selectTree.openChange();
      this.getMerchantUserList();
    });
  },
  methods: {
    // 归属业务员
    getMerchantUserList() {
      this.$http({
        url: '/buz/userBase/queryMerchantUser',
        type: 'get',
        data: {
          merId: this.formData.tenantId
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    }
  }
};
</script>
